import { IApiResponse } from '@shared/interface/api-response.interface';
import { apiPost } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { ApiStatusEnum } from '@shared/enum/api-enum';
import { ApiError } from '@shared/error/api.error';
import { manageApiError } from './common/api.lib';

/**
 * Send an email to the admins
 * @param params
 * @returns
 */
export interface IApiPostMessage {
  email: string;
  subject: string;
  message: string;
  version?: string;
  csrf?: string;
}
export const apiPostMessage = (
  params: IApiPostMessage,
): Promise<IApiResponse<string, string> | undefined> => {
  const endpointClass = endpoints.contact.postMessage;
  return apiPost(endpointClass.getUrl(), params, {
    publicApi: endpointClass.isPublic(),
  })
    .then((response?: IApiResponse<string, string>) => {
      if (
        response != null &&
        response.returnCode === 'CONTACT_OK' &&
        response.returnStatus === ApiStatusEnum.SUCCESS
      ) {
        return response;
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiPostMessage'),
    );
};
